export enum DatovkaNastaveniArchivaceValue {
	DataBoxMessages = 'DZ',
	LargeDataboxMessage = 'VSE',
}
